import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Text from '@lightspeed/cirrus-text';

import PageActionBar from 'pages/components/PageActionBar';

const BrandsActionBar = ({
  onSubmit,
  isLoading,
  submitForm,
  dirty,
  isSubmitting,
  onDelete,
  isDeleting,
}) => (
  <PageActionBar dirty={dirty} submitForm={submitForm}>
    {!isLoading ? (
      <Group className="cr-justify-between cr-width-full">
        <Group>
          <Button
            onClick={onSubmit}
            variant="secondary"
            fill
            disabled={!dirty}
            loading={isSubmitting}
            data-test="retail-action-bar-save"
          >
            Save Changes
          </Button>
          {dirty ? (
            <Text body dimmed>
              Unsaved Changes
            </Text>
          ) : null}
        </Group>

        {onDelete && (
          <Button
            variant="danger"
            fill
            loading={isDeleting}
            disabled={isSubmitting || isLoading}
            onClick={() => {
              // eslint-disable-next-line no-alert
              if (confirm('Are you sure you want to Delete?')) onDelete();
            }}
            data-test="retail-action-bar-delete"
          >
            Delete
          </Button>
        )}
      </Group>
    ) : null}
  </PageActionBar>
);

export default BrandsActionBar;
